<script setup lang="ts">
import InputNumber from '@/components/input-number.vue';
import InvoiceSkeletonPlaceholderText from '@/features/invoices/components/partials/InvoiceSkeletonPlaceholderText.vue'
import { formatDateOnly } from '@/shared/date-only'

defineProps<{
  invoiceNumber?: string
  date?: string
  dateFormat: string
  period?: [string, string]
  isManualInvoice: boolean
  recsEnabled: boolean
}>()
const recsGenerated = defineModel<number>('recsGenerated')
</script>

<template>
  <div :class="$style.wrapper" class="d-grid">
    <span>Invoice Number</span>
    <span>
      <template v-if="invoiceNumber">{{ invoiceNumber }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span>Invoice Date</span>
    <span>
      <template v-if="date">{{ formatDateOnly(date, dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>
    
    <span>Invoice Period</span>
    <span>
      <template v-if="period">{{ formatDateOnly(period[0], dateFormat) }} - {{ formatDateOnly(period[1], dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <template v-if="recsEnabled">
      <span>REC's Generated</span>
      <span>
        <InputNumber v-if="recsGenerated != null" v-model:value="recsGenerated" />
        <InvoiceSkeletonPlaceholderText v-else />
      </span>
    </template>
  </div>
</template>

<style module lang="scss">
.wrapper {
  grid-template-columns: 1fr 1fr;
}
</style>
